// resources/js/woocommerce/account/social-auth.js

const SELECTOR_ROOT   = '.wk-social-login';
// Ondersteun zowel <a href> als <button data-href>
const SELECTOR_BUTTON = 'a[data-provider][href], button[data-provider][data-href]';

function openPopup(url, title, w = 520, h = 640) {
  try {
    const dualLeft = window.screenLeft ?? window.screenX ?? 0;
    const dualTop  = window.screenTop  ?? window.screenY ?? 0;
    const width  = window.innerWidth  || document.documentElement.clientWidth  || screen.width;
    const height = window.innerHeight || document.documentElement.clientHeight || screen.height;
    const left = Math.max(0, (width - w) / 2 + dualLeft);
    const top  = Math.max(0, (height - h) / 2 + dualTop);
    const features = [
      'toolbar=no','location=no','status=no','menubar=no',
      'scrollbars=yes','resizable=yes',
      `width=${w}`,`height=${h}`,`top=${top}`,`left=${left}`
    ].join(',');
    const win = window.open(url, title, features);
    return win || null;
  } catch (e) {
    console.error('[social-auth] openPopup error:', e);
    return null;
  }
}

// Decode &amp; en &#038; naar &
function decodeHref(raw) {
  if (!raw) return '';
  return raw.replace(/&amp;|&#0*38;/gi, '&');
}
function stripPopupParam(u) {
  return u.replace(/([?&])popup=1(&|$)/, '$1').replace(/[?&]$/, '');
}
function getHrefFromBtn(el) {
  if (!el) return '';
  if (el.tagName === 'A') return el.getAttribute('href') || '';
  return el.getAttribute('data-href') || '';
}

function wireSocialLogin(root) {
  if (!root || root.dataset.wkBound === '1') return;
  root.dataset.wkBound = '1';

  root.addEventListener('click', (e) => {
    const btn = e.target.closest(SELECTOR_BUTTON);
    if (!btn || !root.contains(btn)) return;

    // We handelen de klik zelf af.
    e.preventDefault();

    const provider = (btn.getAttribute('data-provider') || '').trim();
    const rawHref  = getHrefFromBtn(btn).trim();
    const href     = decodeHref(rawHref);

    if (!href || !provider) return;

    const win = openPopup(href, `${provider}-login`, 520, 640);

    // Alleen als popup écht niet opent → normale redirect
    if (!win) {
      window.location.assign(stripPopupParam(href));
      return;
    }

    // Succes: sluit popup & refresh parent
    const onMsg = (ev) => {
      if (ev?.data?.type === 'webkust:oauth:success') {
        try { win.close(); } catch {}
        window.location.reload();
      }
    };
    window.addEventListener('message', onMsg, { once: true });
  });
}

export function mount() {
  document.querySelectorAll(SELECTOR_ROOT).forEach(wireSocialLogin);
}

// Auto-bind
if (document.readyState === 'interactive' || document.readyState === 'complete') {
  try { mount(); } catch {}
} else {
  document.addEventListener('DOMContentLoaded', () => { try { mount(); } catch {} });
}
